import axios from "axios";
import {PageOwnerDto} from "types/DTOs/pageOwnerDto";


export const getAllOwners = async() => {
  const {data} = await axios.get<PageOwnerDto>(`super/owners`)
  return data
}
